import React from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';
var BoolValue = function BoolValue(_ref) {
  var vm = _ref.vm;
  return /*#__PURE__*/React.createElement("div", {
    className: "prompt-line__text"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('answer-boolean', !vm.answer && 'black'),
    "data-test": "bool-answer"
  }, typeof vm.answer !== 'boolean' ? '' : vm.answer ? 'Yes' : 'No'));
};
export default observer(BoolValue);
//# sourceMappingURL=index.js.map
